<template>
  <CompanyObjectRefSelect
    v-model="vModel"
    :options="companyDimensionOptions"
    :mode="mode"
    object-type="company_dimension"
    placeholder="Dimension"
    external-path="/definitions"
    :external-query="{
      tab: 'dimensions',
    }" />
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import CompanyObjectRefSelect from '@/components/reports/config/common/CompanyObjectRefSelect'

  export default {
    name: 'CompanyDimensionRefSelect',
    components: {
      CompanyObjectRefSelect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
  }
</script>

<style lang="scss" scoped>

</style>
